import React, { useState, useEffect } from "react";
import Header from "../Components/header";
import Sidebar from "../Components/sidebar";
import axios from "axios";
import { OrderDetails } from "../Components/modalPopup";

const API_URL = process.env.REACT_APP_API_URL;

const SearchInput = ({ value, onChange, placeholder = "Cerca..." }) => {
  return (
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="p-2 border w-full max-w-lg border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder-gray-500"
    />
  );
};

const GestioneOrdini = () => {
  const [ordini, setOrdini] = useState(null);
  const [ordineModificato, setOrdineModificato] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [dettaglioOrdine, setDettaglioOrdine] = useState(null); // Stato per il dettaglio dell'ordine
  const [orderDetailsIsOpen, setOrderDetailsIsOpen] = useState(false); // Stato per il dettaglio dell'ordine
  const [isLoadingOrderDetails, setIsLoadingOrderDetails] = useState(false);
  const [editError, setEditError] = useState(null);
  const [editUserId, setEditUserId] = useState(null);

  /*FETCH ORDINI */
  useEffect(() => {
    const fetchOrdine = async () => {
      try {
        axios.defaults.withCredentials = true;
        const response = await axios.get(`${API_URL}/admin/orders`);
        console.log(response);
        setOrdini(response.data.ordini || []);
        setIsLoading(false);
        setFilteredOrders(response.data.ordini || []);
      } catch (error) {
        console.error("Error fetching issues:", error);
      }
    };
    fetchOrdine();
  }, []);

  /* RECUPERA DETTAGLI ORDINE */

  const recuperaDettagliOrdine = async (id) => {
    setIsLoadingOrderDetails(true); // Avvia il caricamento dei dettagli
    axios.defaults.withCredentials = true;
    try {
      const response = await axios.get(`${API_URL}/admin/orderDetails/${id}`);
      console.log("QUI");

      console.log(response.data);

      console.log(dettaglioOrdine);
      await setDettaglioOrdine((prevDettaglioOrdine) => ({
        ...prevDettaglioOrdine,
        ...response.data,
      }));
      console.log(dettaglioOrdine);
      setIsLoadingOrderDetails(false); // Ferma il caricamento dei dettagli
      setOrderDetailsIsOpen(true); // Apri il modale solo dopo il caricamento
    } catch (error) {
      console.error("Error fetching order details:", error);
      setIsLoadingOrderDetails(false); // Ferma il caricamento anche in caso di errore
    }
  };

  const handleChange = (id) => {
    const elementoTrovato = ordini.find((order) => order.id === id);
    const completatoCorrente = Boolean(elementoTrovato.completato);

    const statoAttuale =
      id in ordineModificato ? ordineModificato[id] : completatoCorrente;
    const nuovoStato = !statoAttuale;

    setOrdineModificato((prevData) => {
      const aggiornato = { ...prevData };
      if (nuovoStato === completatoCorrente) {
        delete aggiornato[id];
      } else {
        aggiornato[id] = nuovoStato;
      }
      return aggiornato;
    });

    setOrdini((prevData) => {
      const aggiornato = [...prevData];
      const elementoTrovato = aggiornato.find((order) => order.id === id);
      if (elementoTrovato) {
        elementoTrovato.completato = nuovoStato;
      }
      return aggiornato;
    });

    if (dettaglioOrdine) {
      setDettaglioOrdine((prevData) => ({
        ...prevData,
        completato: nuovoStato,
      }));
    }

    updateOrders(id, nuovoStato);
  };

  const updateOrders = async (id, nuovoStato) => {
    console.log("Updating order:", ordineModificato);
    axios.defaults.withCredentials = true;
    try {
      const response = await axios.post(`${API_URL}/admin/updateOrders`, {
        id: id,
        completato: nuovoStato,
      });
      console.log(response.data);
    } catch (error) {
      console.error("Error updating order:", error);
    }
  };

  const handleViewDetails = (order) => {
    setDettaglioOrdine(order);
  };

  useEffect(() => {
    if (dettaglioOrdine?.id) {
      recuperaDettagliOrdine(dettaglioOrdine.id);
      setOrderDetailsIsOpen(true);
    }
  }, [dettaglioOrdine?.id]);

  const closeModal = () => {
    setDettaglioOrdine(null);
  };

  /* APRI MODALE MODIFICA ABBONAMENTO */
  const handleOpenOrderModal = () => {
    setOrderDetailsIsOpen(true);
  };

  /* CHIUDI MODALE MODIFICA UTENTE */
  const handleCloseOrderModal = () => {
    setDettaglioOrdine(null); // Reset dell'ID utente
    console.log("CHIUDENDO");
    setOrderDetailsIsOpen(false);
    //setUserData({ nome: "", cognome: "", email: "", num_tel: "", ruolo: "" }); // Reset dei dati utente
  };

  const handleSearchChange = (value) => {
    setSearchTerm(value);
    setFilteredOrders(filteredData(value));
    //applyFilter(selectedStatus, event.target.value);
  };

  const filteredData = (search) =>
    ordini.filter((item) => {
      const nome = item.nome || "";
      const cognome = item.cognome || "";
      const email = item.email || "";
      const num_tel = item.num_tel || "";
      const codice_ordine = item.codice_ordine || "";
      const data_ordine = item.data_ordine || "";
      const id = item.id.toString() || "";
      console.log(id);

      return (
        nome.toLowerCase().includes(search.toLowerCase()) ||
        cognome.toLowerCase().includes(search.toLowerCase()) ||
        email.toLowerCase().includes(search.toLowerCase()) ||
        num_tel.toLowerCase().includes(search.toLowerCase()) ||
        id.toLowerCase().includes(search.toLowerCase()) ||
        codice_ordine.toLowerCase().includes(search.toLowerCase()) ||
        data_ordine.toLowerCase().includes(search.toLowerCase())
      );
    });

  return (
    <div>
      <Header />
      <div className="flex min-h-screen">
        <Sidebar />
        <div className="flex flex-col flex-1 p-6 bg-gray-100">
          <h1 className="text-3xl font-bold mb-6 text-gray-800">
            Gestione ordini
          </h1>
          <div className="flex justify-between items-center mb-6">
            <SearchInput
              onChange={handleSearchChange}
              placeholder="Cerca per n° ordine, nome, cognome, email o numero di telefono"
            />
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-full">
              <thead>
                <tr className="bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
                  <th className="py-3 px-4 border-b">N° ordine</th>
                  <th className="py-3 px-4 border-b">Nome</th>
                  <th className="py-3 px-4 border-b">Email</th>
                  <th className="py-3 px-4 border-b">Link pagamento</th>
                  <th className="py-3 px-4 border-b">Data ordine</th>
                  <th className="py-3 px-4 border-b">Spedito</th>
                  <th className="py-3 px-4 border-b">Azioni</th>
                </tr>
              </thead>
              {ordini && ordini.length > 0 ? (
                <tbody className="text-gray-700 text-md">
                  {filteredOrders.map((order, index) => (
                    <tr
                      key={index}
                      className="hover:bg-gray-100 transition duration-200"
                    >
                      <td className="py-2 px-4 border-b border-x">
                        {order.codice_ordine || order.id || ""}
                      </td>
                      <td className="py-2 px-4 border-b border-x">
                        {`${order.cognome || ""} ${order.nome || ""}`.trim()}
                      </td>
                      <td className="py-2 px-4 border-b border-x">
                        {order.email}
                      </td>
                      <td className="py-2 px-4 border-b border-x">
                        <a
                          href={`https://dashboard.stripe.com/test/payments/${order.id_pagamento}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-500 hover:underline"
                          title="Vai al link"
                        >
                          Link pagamento
                        </a>
                      </td>
                      <td className="py-2 px-4 border-b border-x">
                        {order.created_at
                          ? new Date(order.created_at).toLocaleDateString()
                          : "N/A"}
                      </td>
                      <td className="py-2 px-4 border-b border-x">
                        <input
                          type="checkbox"
                          checked={
                            ordineModificato[order.id] ?? order.completato
                          }
                          onChange={() => handleChange(order.id)}
                        />
                      </td>
                      <td className="py-2 px-4 border-b">
                        <button
                          onClick={() => handleViewDetails(order)}
                          className="bg-blue-500 text-white py-1 px-2 rounded hover:bg-blue-600 transition duration-200"
                        >
                          Visualizza dettagli
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td colSpan="6" className="py-4 text-center text-gray-500">
                      Nessun risultato trovato.
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
          </div>
          {/* Modal per i dettagli dell'ordine */}
          {dettaglioOrdine && !isLoadingOrderDetails && (
            <OrderDetails
              orderData={dettaglioOrdine}
              onChange={(updatedOrder) => handleChange(updatedOrder)}
              isOpen={orderDetailsIsOpen}
              onClose={() => handleCloseOrderModal()}
              onConfirm={() => handleCloseOrderModal()}
              title="Dettagli Ordine"
            />
          )}
          {/*
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded-md shadow-lg max-w-md w-full">
              <h2 className="text-2xl font-bold mb-4">Dettagli Ordine</h2>
              <p>
                <strong>Nome:</strong> {dettaglioOrdine.nome}{" "}
                {dettaglioOrdine.cognome}
              </p>
              <p>
                <strong>Email:</strong> {dettaglioOrdine.email}
              </p>
              <p>
                <strong>Data Ordine:</strong>{" "}
                {new Date(dettaglioOrdine.created_at).toLocaleDateString()}
              </p>
              <p>
                <strong>ID Pagamento:</strong> {dettaglioOrdine.id_pagamento}
              </p>
              <p>
                <strong>Stato Completato:</strong>{" "}
                {dettaglioOrdine.completato ? "Sì" : "No"}
              </p>
              <button
                onClick={closeModal}
                className="bg-red-500 text-white px-4 py-2 rounded mt-4 hover:bg-red-600 transition duration-200"
              >
                Chiudi
              </button>
            </div>
          </div>
          )*/}
        </div>
      </div>
    </div>
  );
};

export default GestioneOrdini;
